import styled from 'styled-components';

import { Separator } from '@components/separator';
import { pxToRem } from '@utils/converters';

export const FilterListSeparator = styled(Separator)({
  margin: `${pxToRem(16)} 0`,
});
